import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'

import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { Yield } from '../../../abacus/interfaces/yield.interface'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'
import { purposeDefinition } from '../purpose.definition'
import { purposeYields } from '../purpose.yields'

import { CommonModule } from '@angular/common'
import { CaseInputComponent } from 'src/app/abacus/elements/inputs/case-input/case-input.component'
import { MetaComponent } from 'src/app/abacus/elements/partials/meta/meta.component'
import { PaginationComponent } from 'src/app/abacus/elements/partials/pagination/pagination.component'
import { TableComponent } from 'src/app/abacus/elements/partials/table/table.component'
import { EurosPipe, HasPermissionDirective } from 'src/app/abacus/standalone-exports'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'

@Component({
    template: caseListTemplate,
    standalone: true,
    imports: [
      CommonModule,
      RouterModule,
      TableComponent,
      EurosPipe,
      PaginationComponent,
      HasPermissionDirective,
      MetaComponent,
      CaseInputComponent
    ]
})
export class PurposeListComponent extends CaseListComponent implements OnInit {
  definition: ResourceDefinition = purposeDefinition
  yields: Yield[] = purposeYields

  filters: Filter[] = []

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
